import React from 'react';

function B2BService(props) {
    const { position } = props
    return (
        <div className={`my-2 d-flex ${position==="left" & window.innerWidth>765 && "flex-row-reverse text-right" }   `} >
            <div className="align-self-center">
                <ion-icon name="desktop-outline"  style={{ fontSize: "40px",color:"white" }}></ion-icon>
            </div>
            <div className={` px-3`}>
                <h4 className="white-3">Lorem ipsum dolor sit amet.</h4>
                <p className="white-1">Lorem ipsum dolor sit amet consectetur adipisicing elit. Q</p>
            </div>
            
        </div>
    )
}

export default B2BService;

